/* DeLusso · Outlet Baja — lead capture -> Klaviyo (client API, publikus kulcs)
   A natív Shopify contact form MEGMARAD: az iroda továbbra is megkapja a nyers leadet.
   Ez a script ezen felül küldi az adatot Klaviyóba (lista + esemény). */
(function () {
  'use strict';

  var COMPANY_ID = 'UCb2JC';   // Klaviyo public API key
  var LIST_B2C   = 'VNjT5c';   // Outlet Baja 2026 – regisztrálók
  var LIST_B2B   = 'T9ZR22';   // B2B Baja Outlet — partnerlista
  var METRIC     = 'Outlet Baja Regisztráció';
  var REVISION   = '2024-10-15';
  var BASE       = 'https://a.klaviyo.com/client/';

  /* A szekció tényleges mezőnevei -> Klaviyo property nevek. */
  var MAP = {
    'jon':            'outlet_intent',     // foglal / nez / nem
    'name':           '__name',
    'email':          '__email',
    'phone':          '__phone',
    'szek_db':        'outlet_darab_sav',
    'keret':          'outlet_keret',
    'mikor_cserel':   'outlet_surgosseg',
    'idosav':         'outlet_slot',
    'letszam':        'outlet_letszam',
    'hova':           'outlet_szegmens',   // otthon / uzlet
    'egyseg':         'outlet_cegnev',
    'bajai_lakos':    'outlet_helyi_lakos',
    'adatvedelem':    '__skip',
    'hirlevel':       '__marketing',
    'subject':        '__skip',
    'body':           '__skip'
  };

  function findForm() {
    return document.querySelector('[data-form]') ||
           document.querySelector('form[action*="/contact"]');
  }

  function cleanKey(k) {
    var m = k.match(/^contact\[(.+)\]$/);
    return (m ? m[1] : k).trim();
  }

  function collect(form) {
    var fd = new FormData(form);
    var out = { props: {}, name: '', email: '', phone: '', marketing: false, segment: '' };
    var seen = {}, termek = [];

    fd.forEach(function (v, rawKey) {
      var k = cleanKey(rawKey);
      if (!k || k === 'form_type' || k === 'utf8' || k === 'g-recaptcha-response') return;
      var val = typeof v === 'string' ? v.trim() : '';
      if (!val) return;
      /* a termékválasztó mezői: contact[termek_1], contact[termek_x1726...] */
      if (/^termek_/.test(k)) { termek.push(val); return; }
      seen[k] = seen[k] ? seen[k] + ', ' + val : val;
    });

    if (termek.length) out.props.outlet_termek = termek.join(', ');

    Object.keys(seen).forEach(function (k) {
      var val = seen[k], target = MAP[k];

      if (target === '__skip')      return;
      if (target === '__name')      { out.name = val; return; }
      if (target === '__email')     { out.email = val; return; }
      if (target === '__phone')     { out.phone = val; return; }
      if (target === '__marketing') { out.marketing = true; return; }

      if (!target) target = 'outlet_' + k.replace(/[^a-z0-9]+/gi, '_').toLowerCase();
      if (target === 'outlet_szegmens') out.segment = val;
      out.props[target] = val;
    });

    var ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) out.props.outlet_ref = ref;
    out.props.outlet_forras   = 'Outlet Baja landing';
    out.props.outlet_page_url = window.location.href;

    return out;
  }

  function splitName(full) {
    if (!full) return { first: '', last: '' };
    var p = full.split(/\s+/);
    if (p.length === 1) return { first: p[0], last: '' };
    return { last: p[0], first: p.slice(1).join(' ') };   // magyar sorrend
  }

  function post(path, body) {
    return fetch(BASE + path + '?company_id=' + COMPANY_ID, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).catch(function (e) { if (window.console) console.warn('[outlet/klaviyo]', e); });
  }

  function profileAttrs(d) {
    var n = splitName(d.name);
    var a = { properties: d.props };
    if (d.email) a.email = d.email;
    if (d.phone) a.phone_number = d.phone;
    if (n.first) a.first_name = n.first;
    if (n.last)  a.last_name = n.last;
    return a;
  }

  function send(d) {
    if (!d.email) return;

    /* 1) Esemény — ez indítja a visszaigazoló flow-t és létrehozza a profilt.
          Marketing hozzájárulást NEM ad. */
    post('events/', {
      data: {
        type: 'event',
        attributes: {
          properties: d.props,
          metric:  { data: { type: 'metric',  attributes: { name: METRIC } } },
          profile: { data: { type: 'profile', attributes: profileAttrs(d) } }
        }
      }
    });

    /* 2) Listára tétel — csak külön hírlevél checkbox esetén. */
    if (!d.marketing) return;
    var listId = /uzlet|horeca|b2b/i.test(d.segment || '') ? LIST_B2B : LIST_B2C;
    post('subscriptions/', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Outlet Baja landing',
          profile: {
            data: {
              type: 'profile',
              attributes: Object.assign(profileAttrs(d), {
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              })
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }

  function init() {
    var form = findForm();
    if (!form || form.dataset.klaviyoBound) return;
    form.dataset.klaviyoBound = '1';
    form.addEventListener('submit', function () {
      try { send(collect(form)); } catch (e) { if (window.console) console.warn('[outlet/klaviyo]', e); }
      /* nincs preventDefault: a Shopify contact form normálisan elmegy */
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
